(function () {
  'use strict';
  const money = n => (n / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const ratio = (n, target) => Math.max(0, Math.min(100, Math.round(n / target * 100)));
  function model(cart, config, region) {
    const copy = config.copy || {};
    const format = (key, values, fallback) => copy[key] ? copy[key].replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match) : fallback;
    const excluded = new Set((config.excluded || []).map(String));
    const eligible = (cart.items || []).filter(item => typeof window !== 'undefined' && window.HolyCartConsistency ? window.HolyCartConsistency.eligible(item, config.excluded) : (!excluded.has(String(item.product_id)) && !/vip|exclusivo/i.test(item.handle || '') && Number(item.final_price ?? item.price ?? 1) > 0));
    const quantity = eligible.reduce((n, i) => n + Number(i.quantity || 0), 0);
    const total = eligible.reduce((n, i) => n + Number(i.final_line_price || 0), 0);
    const result = {};
    const tiers = (config.tiers || []).filter(t => t.quantity > 0 && t.label).sort((a, b) => a.quantity - b.quantity);
    if (config.progressEnabled && tiers.length) {
      const next = tiers.find(t => t.quantity > quantity);
      const earned = tiers.filter(t => t.quantity <= quantity).pop();
      const remaining = next ? next.quantity - quantity : 0;
      result.progress = next
        ? { text: format('progress_pending', {quantidade:remaining,itens:remaining===1?'unidade':'unidades',beneficio:next.label}, 'Adicione mais ' + remaining + (remaining===1?' unidade':' unidades') + ' para ganhar ' + next.label), percent:ratio(quantity,next.quantity), earned:false }
        : { text:format('progress_done',{beneficio:earned.label},earned.label+' de desconto liberado!'), percent:100, earned:true };
    }
    if (config.shippingEnabled && region && region.uf && Number.isFinite(Number(region.target)) && Number(region.target) > 0) {
      const target = Number(region.target);
      const earned = cart.total_price >= target;
      result.shipping = {text:earned ? format('shipping_done',{},'Frete grátis liberado!') : format('shipping_pending',{valor:money(target-cart.total_price)},'Faltam '+money(target-cart.total_price)+' para frete grátis'), percent:ratio(cart.total_price,target), earned};
    }
    const gifts = (config.gifts || []).filter(g => g.enabled && g.target > 0).map(g => ({ ...g, value: g.type === 'valor' ? total : quantity, goal: g.type === 'valor' ? g.target * 100 : g.target }));
    if (config.giftsEnabled && gifts.length) {
      const next = gifts.find(g => g.value < g.goal);
      const achieved = gifts.filter(g => g.value >= g.goal);
      result.gift = next ? { text: `${achieved.length ? achieved.length + ' brinde(s) liberado(s) · ' : ''}Faltam ${next.type === 'valor' ? money(next.goal - next.value) : (next.goal - next.value) + ' item(ns)'} para ${next.name}`, percent: ratio(next.value, next.goal), earned: false } : { text: `Seus brindes estão liberados: ${achieved.map(g => g.name).join(' + ')}`, percent: 100, earned: true };
    }
    return result;
  }
  function visibility(mode, campaign, services, afterAdd, count, available) {
    const showServices = services && available && mode !== 'campaign' && (!(mode === 'auto' || (mode === 'both' && afterAdd)) || count > 0);
    return { services: showServices, campaign: campaign && mode !== 'services' && (mode !== 'auto' || !showServices) };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { model, visibility };
  if (typeof window === 'undefined' || customElements.get('hs-top-services')) return;
  class TopServices extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.config = JSON.parse(this.querySelector('[data-hs-service-config]').textContent);
      this.config.copy = JSON.parse(this.querySelector('[data-hs-service-copy]')?.textContent || "{}");
      this.cart = JSON.parse(this.querySelector('[data-hs-service-cart]').textContent);
      this.track = this.querySelector('.hs-services-track');
      this.stickySection = this.closest('.shopify-section');
      this.stickyResize = new ResizeObserver(() => this.syncSticky());
      this.stickyResize.observe(this);
      this.scrollAnchor = Math.max(0, window.scrollY);
      this.headers = [...document.querySelectorAll('.section-header-navigation,.section-header-mobile')];
      this.headers.forEach(header => this.stickyResize.observe(header));
      this.headers.forEach(header => header.querySelectorAll('.header-mobile,.header-navigation').forEach(content => this.stickyResize.observe(content)));
      window.addEventListener('scroll', () => this.onHeaderScroll(), { passive: true, signal });
      window.addEventListener('resize', () => this.syncSticky(), { passive: true, signal });
      window.addEventListener('hs:countdown-layout', () => this.syncSticky(), { signal });
      document.addEventListener('focusin', e => {
        if (this.contains(e.target) || this.headers.some(header => header.contains(e.target))) {
          document.documentElement.classList.remove('hs-header-scroll-hidden');
        }
      }, { signal });
      this.regionUF = this.savedUF();
      this.render();
      const refresh = () => { clearTimeout(this.debounce); this.debounce = setTimeout(() => this.refresh(), 120); };
      window.addEventListener('cart-change', refresh, { signal });
      document.addEventListener('atc-core:added', refresh, { signal });
      window.addEventListener('pageshow', refresh, { signal });
      window.addEventListener('focus', refresh, { signal });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); }, { signal });
      for (const name of ['uf-detected', 'hs:shipping-change']) window.addEventListener(name, e => {
        this.regionUF = e.detail ? e.detail.uf : this.savedUF();
        try { if (this.regionUF) sessionStorage.setItem('hs-service-confirmed-uf', this.regionUF); } catch (_) {}
        this.render();
      }, { signal });
      this.addEventListener('click', e => {
        if (e.target.closest('[data-open-cart]')) window.dispatchEvent(new CustomEvent('show-cart', { detail: true }));
        if (e.target.closest('.hs-services-next')) this.next();
      }, { signal });
      this.addEventListener('shopify:block:select', e => {
        const block = [...this.querySelectorAll('[data-block-id]')].find(el => el.dataset.blockId === e.detail.blockId);
        if (block && !block.hidden) { this.querySelector('[data-hs-services]').hidden = false; this.track.scrollTo({ left: block.offsetLeft - this.track.offsetLeft }); }
      }, { signal });
      if (this.dataset.auto !== 'false') this.timer = setInterval(() => {
        if (!document.hidden && !this.matches(':hover') && !this.contains(document.activeElement)) this.next();
      }, Number(this.dataset.interval) || 6500);
      refresh();
    }
    disconnectedCallback() { this.controller.abort(); this.controller = null; clearTimeout(this.debounce); clearInterval(this.timer); this.stickyResize.disconnect(); this.stickySection?.classList.remove('hs-services-sticky'); document.documentElement.classList.remove('hs-services-pinned', 'hs-header-scroll-hidden'); document.documentElement.style.removeProperty('--hs-pinned-services-height'); }
    syncSticky() {
      const active = this.dataset.sticky !== 'false';
      this.stickySection?.classList.toggle('hs-services-sticky', active);
      document.documentElement.classList.toggle('hs-services-pinned', active);
      const barHeight = this.getBoundingClientRect().height;
      const headerHeight = Math.max(0, ...this.headers.map(header => {
        if (getComputedStyle(header).display === 'none') return 0;
        return Math.max(header.getBoundingClientRect().height, ...[...header.querySelectorAll('.header-mobile,.header-navigation')].map(content => content.getBoundingClientRect().height));
      }));
      const countdownHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--hc-countdown-height')) || 0;
      this.headerStackHeight = countdownHeight + barHeight + headerHeight;
      document.documentElement.style.setProperty('--hs-pinned-services-height', barHeight + 'px');
      document.documentElement.style.setProperty('--hs-header-stack-height', this.headerStackHeight + 'px');
    }
    onHeaderScroll() {
      if (window.matchMedia('(min-width: 1025px)').matches) {
        document.documentElement.classList.remove('hs-header-scroll-hidden');
        this.scrollAnchor = Math.max(0, window.scrollY);
        return;
      }
      if (this.dataset.hideScroll === 'false' || this.dataset.sticky === 'false') { document.documentElement.classList.remove('hs-header-scroll-hidden'); return; }
      const y = Math.max(0, window.scrollY);
      if (document.body.matches('.menu_open,.menu-open,.search-open') || this.headers.some(header => header.contains(document.activeElement))) {
        document.documentElement.classList.remove('hs-header-scroll-hidden');
        this.scrollAnchor = y;
        return;
      }
      if (y <= this.headerStackHeight) {
        document.documentElement.classList.remove('hs-header-scroll-hidden');
        this.scrollAnchor = y;
        return;
      }
      if (Math.abs(y - this.scrollAnchor) < 8) return;
      document.documentElement.classList.toggle('hs-header-scroll-hidden', y > this.scrollAnchor);
      this.scrollAnchor = y;
    }
    savedUF() { try { return sessionStorage.getItem('ipLocation') === 'definida' && sessionStorage.getItem('ipCountry') === 'BR' ? sessionStorage.getItem('ufSelecionada') : sessionStorage.getItem('hs-service-confirmed-uf'); } catch (_) { return null; } }
    render() {
      const uf = this.regionUF && this.regionUF.toLowerCase();
      const state = model(this.cart, this.config, { uf, city: window.holyfoodsShippingCity ? window.holyfoodsShippingCity() : '', target: window.holyfoodsShippingEligible && window.holyfoodsShippingEligible(uf) ? Math.round(Number((window.holyfoodsShippingConfig || {})[uf]) * 100) : 0 });
      this.querySelectorAll('[data-service]').forEach(block => {
        const type = block.dataset.service;
        if (type === 'text') { block.hidden = this.cart.item_count > 0; return; }
        const data = state[type];
        block.hidden = !data || (this.cart.item_count === 0 && (type === 'progress' || type === 'gift' || type === 'shipping')); 
        if (!data) return;
        block.querySelector('.hs-service-copy').textContent = data.text;
        block.classList.toggle('is-earned', !!data.earned);
        const meter = block.querySelector('.hs-service-meter');
        if (meter) {
          meter.hidden = true;
        }
      });
      const visibleBlocks = this.querySelectorAll('[data-service]:not([hidden])').length;
      const view = visibility(this.dataset.mode || 'auto', this.dataset.campaign !== 'false', this.dataset.services !== 'false', this.dataset.afterAdd === 'true', this.cart.item_count, visibleBlocks > 0);
      this.querySelector('[data-hs-campaign]').hidden = !view.campaign;
      this.querySelector('[data-hs-services]').hidden = !view.services;
      this.querySelector('.hs-services-next').hidden = visibleBlocks < 2;
      this.syncSticky();
    }
    next() {
      if (this.querySelector('[data-hs-services]').hidden) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max < 2) return;
      const card = this.track.querySelector('[data-service]:not([hidden])');
      this.track.scrollTo({ left: this.track.scrollLeft >= max - 5 ? 0 : Math.min(max, this.track.scrollLeft + card.getBoundingClientRect().width), behavior: 'smooth' });
    }
    async refresh() {
      if (this.busy) { this.again = true; return; }
      this.busy = true;
      try {
        const response = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: this.controller.signal });
        if (!response.ok) throw new Error('cart unavailable');
        const cart = await response.json();
        if (Array.isArray(cart.items) && Number.isFinite(cart.total_price)) { this.cart = cart; this.render(); }
      } catch (_) { /* Keep the last confirmed cart state on a transient failure. */ }
      finally { this.busy = false; if (this.again && this.isConnected) { this.again = false; this.refresh(); } }
    }
  }
  customElements.define('hs-top-services', TopServices);
})();
